export default __webpack_public_path__ + "24b2bcb94349710b7f203c999d593810.svg";